import {uniqueId} from 'lodash';

export default {
    event: (action, eventId, objectType, objectId, objectDetail, context) => ({
        type: 'COLLECT_EVENT',
        payload: {
            id: uniqueId('statistics-report-'),
            timestamp: new Date().toISOString(),
            report: {
                eventId,
                action,
                objectType,
                objectId,
                objectDetail,
                context,
            },
        },
    }),
    reportSuccess: ids => ({type: 'COLLECT_EVENTS_REPORTED', ids}),
};
